import React from "react";

const Upload = () => {
  return null;
};

export default Upload;
